import { useContext, useEffect, useState } from "react"
import './Filter.css';
import { AppContext } from "../../../Context";

export const FilterButton = () => {
    const [colorSearch, setColorSearch] = useState("btn-filter-off");
    const {filterdto,setFilterdto} = useContext(AppContext);

    const addFilter = (e) => {
        let valor = e.target.value;
        if (valor === undefined || valor === "") {
            setFilterdto(undefined);
            setColorSearch("btn-filter-off");
        } else {           
            setFilterdto(valor);
            setColorSearch("btn-filter-on");
        }
    }


    return (
        <>
                <div className="input-field "> 
                    <input
                        type="text"
                        id="_filter"
                        name="_filter"
                        autoComplete="off"
                        onChange={(e)=>addFilter(e)}
                    />
                    <label htmlFor="_filter"><i className={"material-icons "+colorSearch}>search</i> Pesquisar </label>
                </div>
        </>
    );
}


export const useTableFilters = (column, element, data) => {
    
    const setFilter = () => {
        console.log(column);
        console.log(element);
    };


    return {
        setFilter,
    }

}